import React, { Component, createRef } from "react";
import DocumentMeta from "react-document-meta";
import { withRouter } from "react-router-dom";
import styles from "./OpenInterestStyles.js";
import { Grid } from "@material-ui/core";
import { zoomPercent } from "../UnusualOptionsActivity/zoomFunction.js";
import OIRightPanel from "./components/OIRightPanel";
import OIChartModal from "./components/OIChartModal";
import { connect } from "react-redux";
import ActionTypes from "../../actions/types";
import SearchAndGo from "./components/mobileViewComponents/searchandGo";
import OISearchForm from "./components/mobileViewComponents/OISearchForm";
import OIStyle from "./index.module.css";
import {
  calcChartDatas,
  fetchEarningDates,
  keyPressed,
  OIPercentFunction,
  OIbarOptionsPutsBottom,
  OIbarOptionsCallsBottom,
  OIbarOptionsPutsfuntion,
  barOptionsCallsFuntion,
  OIPutData,
  OICallData,
  OIselectDateFunction,
  OIremoveDateFunction,
  OItargetFromChangeFunction,
  OItargetToChangeFunction,
  selectDateAndSaveTicker,
  OIConditionAndFetch,
} from "./components/utils/utils";
import TopBar from "./components/webViewComponents/topBar";
import OIWebTableContainer from "./components/webViewComponents/OIWebTable";
import OIMobileViewTable from "./components/webViewComponents/OIMobileTable.jsx";

import OITopModal from "./OITopModal.jsx";
import { refreshDataAndExpirationsFunc } from "../../Shared/index.js";

class OpenInterest extends Component {
  constructor(props) {
    super(props);
    this.tableRef = createRef();
    this.modalRef = createRef();
    this.fullRef = createRef();
    this.targetElement = null;
  }
  componentDidMount() {
    (async () => {
      this.props.loginCheck();
      const ticker = this.props.match.params.ticker;
      if (ticker) {
        await this.props.setAppStateAction({
          ticker: ticker,
          quoteInfo: {
            ...this.props.appState.quoteInfo,
            symbol: ticker,
          },
        });
      }
      await this.fetchEarningDate();
      selectDateAndSaveTicker(this.props);
    })();
  }
  componentWillUnmount() {
    localStorage.setItem("SYMBOL", this.props.state.localTicker);
    localStorage.setItem("TYPE", "");
  }
  async componentDidUpdate(prevProps) {
    const obj = {
      prevProps: prevProps,
      props: this.props,
      modalRef: this.modalRef,
      tableRef: this.tableRef,
    };
    await OIConditionAndFetch(obj);
  }
  selectDate = (row) => OIselectDateFunction(row, this.props);

  removeDate = (index) => {
    OIremoveDateFunction(index, this.props);
    this.calcChartData();
  };
  targetFromChange = (event, value) => {
    OItargetFromChangeFunction(value, this.props);
    var from = parseFloat(value);
    this.props.setStateAction({ from: value, fromValue: from });
  };
  targetToChange = (event, value) => {
    OItargetToChangeFunction(value, this.props);
    var to = parseFloat(value);
    this.props.setStateAction({ to: value, toValue: to });
  };
  handlePercent = async (event, value) => {
    const obj = {
      event: event,
      value: value,
      props: this.props,
    };
    await OIPercentFunction(obj);
  };
  handleCloseVideo = () =>
    this.props.setStateAction({ showVideo: false, onPlay: false });

  handleOpenVideo = () =>
    this.props.setStateAction({ showVideo: true, onPlay: true });

  changeTicker = (event) => {
    const ticker = event.target.value.toUpperCase();
    this.props.changeTicker(ticker);
  };
  keyPress = (e) => {
    const obj = {
      e: e,
      props: this.props,
    };
    keyPressed(obj);
  };
  handleType = () => {
    const { type } = this.props.state;
    if (type === "calls") this.props.setStateAction({ type: "puts" });
    else this.props.setStateAction({ type: "calls" });
  };

  openChart = () => {
    if (this.props.state.dates.length === 0) {
      this.props.setStateAction({ openError: true });
    } else {
      this.calcChartData();
      this.props.setStateAction({ showChart: true });
    }
  };
  closeOIModal = () => {
    this.props.setStateAction({ isOIchecked: false });
  };
  makeModelRowData = (row, cell, dates, cellindex) => {
    const { OIDates } = this.props.appState;
    const put_call = this.props.state.type === "calls" ? "C" : "P";
    const ModelRowData = { strike: row[0], put_call: put_call };
    if (cell !== 0) {
      const expiration = OIDates[cellindex];
      this.props.setStateAction({
        expiration: expiration,
        modalRowData: ModelRowData,
        isOIchecked: true,
      });
    }
  };

  calcChartData = async () => {
    const obj = {
      props: this.props,
      setStateAction: this.props.setStateAction,
      modalRef: this.modalRef,
    };

    await calcChartDatas(obj);
  };

  fetchEarningDate = async () => {
    const obj = {
      props: this.props.appState,
      setStateAction: this.props.setStateAction,
      modalRef: this.modalRef,
    };
    await fetchEarningDates(obj);
  };

  render() {
    const meta = {
      title: this.props.state.localTicker
        ? `${this.props.state.localTicker} Open Interest - OptionsGeek`
        : "Open Interest - OptionsGeek",
      description: this.props.state.localTicker
        ? `This ${this.props.state.localTicker} open interest options chart offers strike prices and options expirations with highest open interest options. Compare Call options vs Put options.`
        : "This IBM open interest options chart offers strike prices and options expirations with highest open interest options. Compare Call options vs Put options.",
      canonical: "https://tools.optionsgeek.com/openinterest",
      keywords:
        "open, interest, marketing, financial, high, options, call, put, analysis",
    };

    const { ticker, width, OIDataCall, OIDataPut, holderList } =
      this.props.appState;

    const isMobile = width < 850;
    let zoom = zoomPercent(window.innerWidth);

    const propsData = {
      props: this.props.appState,
      state: this.props.state,
    };
    const dataCall = OICallData(propsData);
    const dataPut = OIPutData(propsData);
    const propsDataObj = {
      props: this.props,
    };
    const barOptionsCalls = barOptionsCallsFuntion(propsDataObj);
    const barOptionsPuts = OIbarOptionsPutsfuntion(propsDataObj);

    const barOptionRequirement = {
      isMobile: isMobile,
      props: this.props,
    };

    const barOptionsCallsBottom = OIbarOptionsCallsBottom(barOptionRequirement);
    const barOptionsPutsBottom = OIbarOptionsPutsBottom(barOptionRequirement);

    let lengthCheck = false;
    if (Object.keys(holderList).length > 0) {
      if (holderList.hieghestCalls.length || holderList.hieghestPuts.length) {
        lengthCheck = true;
      }
    }

    return (
      <div>
        <DocumentMeta {...meta}>
          <div
            style={
              !isMobile
                ? {
                  ...styles.mainContainer,
                  margin: window.innerWidth > 2000 ? "auto" : "",
                  width: window.innerWidth > 2000 ? "1600px" : "",
                }
                : styles.mainMobile
            }
            ref={this.fullRef}
          >
            <OITopModal
              onPlay={this.props.appState.onPlay}
              handleCloseVideo={() => this.handleCloseVideo()}
              styles={styles}
            />

            <OIChartModal
              handleCloseChart={() =>
                this.props.setStateAction({ showChart: false })
              }
              styles={styles}
              state={this.props.state}
              setState={(data) => this.props.setStateAction(data)}
              lengthCheck={lengthCheck}
              removeDate={(data) => this.removeDate(data)}
              modalRef={this.modalRef}
              dataCall={dataCall}
              barOptionsCalls={barOptionsCalls}
              dataPut={dataPut}
              barOptionsPuts={barOptionsPuts}
              barOptionsCallsBottom={barOptionsCallsBottom}
              barOptionsPutsBottom={barOptionsPutsBottom}
            />
            {!isMobile && (
              <Grid container spacing={0} style={{ zoom: zoom }}>
                <Grid item xs={12} sm={12} md={9} style={{ height: "100%" }}>
                  <TopBar
                    styles={styles}
                    lengthCheck={lengthCheck}
                    changeTicker={(event) => this.changeTicker(event)}
                    keyPress={(event) => this.keyPress(event)}
                    refreshOpenInterest={this.props.refreshOpenInterest}
                    handleType={this.handleType}
                    openChart={this.openChart}
                    refreshDataAndExpirations={(ticker) =>
                      refreshDataAndExpirationsFunc(
                        ticker,
                        this.props.state.selectedDate,
                        this.props.appState,
                        this.props.setAppStateAction
                      )
                    }
                    targetFromChange={(event, data) =>
                      this.targetFromChange(event, data)
                    }
                    targetToChange={(event, data) =>
                      this.targetToChange(event, data)
                    }
                    handlePercent={(event, data) =>
                      this.handlePercent(event, data)
                    }
                  />

                  <OIWebTableContainer
                    props={this.props.appState}
                    styles={styles}
                    tableRef={this.tableRef}
                    closeOIModal={this.closeOIModal}
                    lengthCheck={lengthCheck}
                    dates={this.props.state.dates}
                    callsData={OIDataCall}
                    putsData={OIDataPut}
                    selectDate={(row) => this.selectDate(row)}
                    makeModelRowData={async (row, cell, dates, cellindex) => {
                      this.makeModelRowData(row, cell, dates, cellindex);
                    }}
                  />
                </Grid>
                <OIRightPanel styles={styles} />
              </Grid>
            )}
            {isMobile && (
              <React.Fragment>
                <div className={OIStyle.OIisMObileContainer}>
                  <SearchAndGo
                    styles={styles}
                    changeTicker={(event) => this.changeTicker(event)}
                    keyPress={(event) => this.keyPress(event)}
                    refreshOpenInterest={this.props.refreshOpenInterest}
                  />
                  <OISearchForm
                    styles={styles}
                    setShowModal={() =>
                      this.props.setStateAction({ holderModal: false })
                    }
                    lengthCheck={lengthCheck}
                    refreshDataAndExpirations={() =>
                      refreshDataAndExpirationsFunc(
                        ticker,
                        this.props.state.selectedDate,
                        this.props.appState,
                        this.props.setAppStateAction
                      )
                    }
                    targetFromChange={(event, data) =>
                      this.targetFromChange(event, data)
                    }
                    targetToChange={(event, data) =>
                      this.targetToChange(event, data)
                    }
                    handlePercent={(event, data) =>
                      this.handlePercent(event, data)
                    }
                  />
                </div>
                <Grid container spacing={0} style={{ zoom: zoom }}>
                  <Grid item xs={12} sm={12} md={12} style={{ height: "100%" }}>
                    <OIMobileViewTable
                      props={this.props.appState}
                      styles={styles}
                      tableRef={this.tableRef}
                      closeOIModal={this.closeOIModal}
                      lengthCheck={lengthCheck}
                      dates={this.props.state.dates}
                      callsData={OIDataCall}
                      putsData={OIDataPut}
                      handleType={this.handleType}
                      openChart={this.openChart}
                      strikes={this.props.strikes}
                      selectDate={(row) => this.selectDate(row)}
                      makeModelRowData={async (row, cell, dates, cellindex) => {
                        this.makeModelRowData(row, cell, dates, cellindex);
                      }}
                    />
                  </Grid>
                </Grid>
              </React.Fragment>
            )}
          </div>
        </DocumentMeta>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  state: state.OpenInterestState,
  appState: state.appReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_OPEN_INTREST,
      payload: newState,
    }),
  setAppStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: newState,
    }),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(OpenInterest));



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/index.js